import React from "react";

import { CONSTANTS } from "../../../constants/constants";
import searchUserResponseAdapter from "../../../adapters/searchUserAdapter";
import filterProfilesByVertical from "../../../utils/filterProfilesByVertical";

const useStudentProfileResolution = ({
  stateStudentData,
  statePhone,
  queryResult,
  decryptedPhone,
  verticalInfo,
  urlUamId,
  urlAdmissionNumber,
}) => {
  const resolvedProfile = React.useMemo(() => {
    if (stateStudentData) {
      return {
        localStudentData: stateStudentData,
        localPhone: statePhone,
        profilesForSelection: [],
      };
    }

    if (!queryResult?.data?.accounts) {
      return {
        localStudentData: null,
        localPhone: decryptedPhone,
        profilesForSelection: [],
      };
    }

    const matchedProfiles = filterProfilesByVertical(
      queryResult.data.accounts,
      verticalInfo?.id,
      {
        uam_id: urlUamId,
        admission_number: urlAdmissionNumber,
      },
    );

    if (matchedProfiles.length === CONSTANTS.ONE) {
      const [matchedProfile] = matchedProfiles;

      return {
        localStudentData: searchUserResponseAdapter(
          matchedProfile.account,
          matchedProfile.profile,
        ),
        localPhone: matchedProfile.account.phone || decryptedPhone,
        profilesForSelection: [],
      };
    }

    return {
      localStudentData: null,
      localPhone: decryptedPhone,
      profilesForSelection:
        matchedProfiles.length > CONSTANTS.ONE ? matchedProfiles : [],
    };
  }, [
    decryptedPhone,
    queryResult,
    statePhone,
    stateStudentData,
    urlAdmissionNumber,
    urlUamId,
    verticalInfo?.id,
  ]);

  return resolvedProfile;
};

export default useStudentProfileResolution;
